<template>
  <div>
    <!-- 영문 이름 -->
    <div class="item">
      <div class="sub-title">
        {{ "영문 이름"
        }}<span class="keyColor">{{ $t("Verification.common.required") }}</span>
      </div>
      <div class="input-box authID" flex>
        <el-input
          v-model="data.enSurname"
          placeholder="성(Surname)"
          class="half en-name"
        ></el-input>
        <el-input
          v-model="data.enGivenName"
          placeholder="이름(Given name)"
          class="half en-name ml8"
        ></el-input>
      </div>
      <div class="sub keyColor mt4 fs10">
        {{ "* 여권의 영문 이름과 동일하게 입력하세요." }}
      </div>
      <div
        v-if="data.enSurname.length < 2 || data.enGivenName.length < 2"
        class="sub keyColor mt4 fs10"
      >
        {{ "* 영문 이름은 2자 이상 입력하세요." }}
      </div>
    </div>
    <!-- //영문 이름 -->

    <!-- 외국인등록번호 -->
    <div class="item">
      <div class="sub-title">
        {{ "주민등록번호(외국인등록번호)" }}
        <span class="keyColor">{{ $t("Verification.common.required") }}</span>
      </div>
      <div class="input-box authID" flex>
        <div class="detail half en-name">
          {{ birth }}
        </div>
        <el-input
          v-model="data.personalCode"
          type="number"
          pattern="\d*"
          @input="checkNumberLength"
          placeholder="뒤 7자리 입력"
          class="half en-name ml8"
        ></el-input>
        <div class="sub keyColor mt4 fs10">
          {{ ssnCheck(birth, data.personalCode) }}
        </div>
      </div>
    </div>
    <!-- //외국인등록번호 -->

    <!-- 외국인등록증발급일자-->
    <div class="item">
      <div class="sub-title">
        {{ "외국인등록증발급일자" }}
        <span class="keyColor">{{ $t("Verification.common.required") }}</span>
      </div>
      <el-date-picker
        v-model="data.idCardStartDate"
        type="date"
        placeholder="날짜를 선택해 주세요."
        class="idcard-start"
      ></el-date-picker>
    </div>
    <!-- //외국인등록증발급일자 -->

    <!-- 외국인등록증만료일자 -->
    <div class="item">
      <div class="sub-title">
        {{ "외국인등록증만료일자" }}
        <span class="keyColor">{{ $t("Verification.common.required") }}</span>
      </div>
      <el-date-picker
        v-model="data.idCardEndDate"
        type="date"
        placeholder="날짜를 선택해 주세요."
        class="idcard-end"
      ></el-date-picker>
    </div>
    <!-- //외국인등록증만료일자 -->

    <!-- 휴대폰 번호-->
    <div class="item">
      <div class="sub-title">
        {{ "휴대폰 번호" }}
      </div>
      <div class="detail">
        {{ mobilePhone(step1data.foreigner.mobileNo) }}
      </div>
    </div>
    <!-- //휴대폰 번호 -->
    <!-- 주소 -->
    <search-page :searchdata.sync="data.searchData" />
    <!-- //주소 -->

    <div class="keycolor fs10 mt20">
      {{ "본인이 아닌 정보를 입력하시면 입출금 및 이용에 제약을 받습니다." }}
    </div>
    <div class="bottom-button-wrap bottom mt30" flex fjb>
      <button @click="toStep2" class="next-button pre">
        {{ "이전" }}
      </button>
      <button
        @click="toTowThird"
        :disabled="
          this.data.enSurname.length < 2 ||
            this.data.enGivenName.length < 2 ||
            this.data.searchData.addr2 == '' ||
            this.data.activeBtn == false
        "
        class="next-button next"
      >
        다음
      </button>
    </div>
  </div>
</template>

<script>
import searchPage from "./search.vue";

export default {
  props: {
    data: {
      enSurname: String, //3-1 영문 성
      enGivenName: String, //3-1 영문 이름
      personalCode: String, //주민등록번호 뒤 7자리
      idCardStartDate: String, //외국인등록증발급일자
      idCardEndDate: String, //외국인등록증만료일자
      activeBtn: Boolean, // 주민번호 유효성 검사에 따른 다음 버튼 활성화
    },
    step1data: {
      foreigner: {
        mobileNo: String, // 휴대폰 번호
      },
    },
    // 기본정보 주소
    searchData: {
      addr1: String,
      addr2: String,
      addr3: String,
    },
  },
  components: {
    searchPage,
  },
  computed: {
    birth() {
      return this.step1data.foreigner.birthDate.slice(2);
    },
  },
  methods: {
    //input type number 입력수 제한
    checkNumberLength() {
      if (this.data.personalCode.length > 7) {
        this.data.personalCode = this.data.personalCode.slice(0, 7);
      }
    },
    //step2로 이동
    toStep2() {
      this.$emit("tostep2");
    },
    toTowThird() {
      this.$emit("totowthird");
    },
    //주민등록번호 유효성 검사
    ssnCheck(_ssn1, _ssn2) {
      const ssn1 = _ssn1;
      const ssn2 = _ssn2;
      const ssn = ssn1 + ssn2;
      const arr_ssn = [];
      const compare = [2, 3, 4, 5, 6, 7, 8, 9, 2, 3, 4, 5];
      let sum = 0;

      // 생년월일 공백일 때
      if (ssn1 == "") {
        this.data.activeBtn = false;
        return "* 올바른 주민등록 번호를 입력하여 주세요.";
      }

      // 주민번호 뒷자리 공백일 때
      if (ssn2 == "") {
        this.data.activeBtn = false;
        return "* 올바른 주민등록 번호를 입력하여 주세요.";
      }

      // 입력값 체크
      if (ssn1.match("[^0-9]")) {
        this.data.activeBtn = false;
        return "* 올바른 주민등록 번호를 입력하여 주세요.";
      }

      // 입력값 체크
      if (ssn2.match("[^0-9]")) {
        this.data.activeBtn = false;
        return "* 올바른 주민등록 번호를 입력하여 주세요.";
      }

      // 자리수 체크
      if (ssn.length != 13) {
        this.data.activeBtn = false;
        return "* 올바른 주민등록 번호를 입력하여 주세요.";
      }

      // 공식: M = (11 - ((2×A + 3×B + 4×C + 5×D + 6×E + 7×F + 8×G + 9×H + 2×I + 3×J + 4×K + 5×L) % 11)) % 10
      for (let i = 0; i < 13; i++) {
        arr_ssn[i] = ssn.substring(i, i + 1);
      }

      for (let i = 0; i < 12; i++) {
        sum = sum + arr_ssn[i] * compare[i];
      }

      sum = (11 - (sum % 11)) % 10;

      if (sum != arr_ssn[12]) {
        this.data.activeBtn = false;
        return "* 올바른 주민등록 번호를 입력하여 주세요.";
      }
      this.data.activeBtn = true;
      return "";
    },
    //휴대폰 번호 "-" 삽입
    mobilePhone(phoneNumber) {
      const phoneNumberArray = phoneNumber.split("");
      phoneNumberArray.splice(3, 0, "-");
      phoneNumberArray.splice(-4, 0, "-");
      const joinNumber = phoneNumberArray.join("");
      return joinNumber;
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  margin-top: 12px;
  .sub-title {
    margin-bottom: 8px;
    font-size: 12px;
    font-weight: normal;
    line-height: 1.5;
    color: #333;
  }
  .authID {
    .search-address {
      width: 62px;
      padding: 10px 0px 11px;
      font-size: 12px;
      color: #333;
      border: 1px solid #dcdfe3;
      border-radius: 0 2px 2px 0;
      background-color: #fff;
    }
    .one-fifth {
      width: calc(100% - 62px);
      border: 1px solid #dcdfe3;
      border-right: 0 solid;
      border-right: 0;
      border-radius: 2px 0 0 2px;
    }
  }
  .detail {
    padding: 11px 0 11px 8px;
    border-radius: 2px;
    border: solid 1px #dcdfe3;
    background-color: #f7f8fa;
    &.full-box {
      height: 38px;
      color: #333;
      background-color: #fff;
    }
    &.dropdown {
      position: relative;
      color: #afafaf;
      background-color: #fff;
      &:after {
        content: "";
        position: absolute;
        top: 13px;
        right: 9px;
        width: 6.7px;
        height: 12px;
        background-image: url("../../../../../../assets/img/mypage/button_arrow_right_icon.svg");
        background-size: 6.7px 12px;
        background-repeat: no-repeat;
      }
      &.selected {
        color: #333;
        border: solid 1px #00b473;
        background-color: #f2fbf8;
      }
      &.change {
        color: #333;
        border: solid 1px #00b473;
        background-color: #f2fbf8;
      }
      &.reject {
        color: #333;
        border: solid 1px #eb3246;
        background-color: #fff;
      }
    }
  }
  .input-box {
    .en-name.half {
      width: calc((100% - 12px) / 2);
    }
  }
}
.dropdown-list {
  list-style: none;
  li {
    padding: 20px 12px;
    font-size: 12px;
    font-weight: 500;
    &.padding-change {
      padding: 11px 12px;
    }
    .detail {
      padding-left: 27px;
      margin-bottom: 2px;
      font-size: 10px;
      font-weight: normal;
      line-height: 1.8;
      color: #999;
    }
    .list-item-title {
      position: relative;
      padding-left: 20px;
      .arrow {
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        width: 0;
        height: 0;
        border-left: 5px solid #333;
        border-top: 5px solid transparent;
        border-bottom: 5px solid transparent;
        &.open {
          width: 0;
          height: 0;
          border-left: 5px solid transparent;
          border-right: 5px solid transparent;
          border-top: 6px solid #333;
          border-bottom: 0;
        }
      }
    }

    ul {
      list-style: none;
    }
  }

  &-description {
    font-size: 10px;
    color: #999;
    margin-top: 5px;
    font-weight: normal;
  }
}
// 하단 버튼
button.next-button {
  width: 100%;
  padding: 10px 0;
  font-size: 12px;
  border-radius: 2px;
  border: 1px solid #00b473;
  background-color: #00b473;
  &.pre {
    width: 96px;
    color: #333;
    border: 1px solid #eeeeee;
    background-color: #fff;
  }
  &.next {
    width: calc(100% - 104px);
  }
  &.bottom {
    position: absolute;
    bottom: 32px;
    left: 50%;
    transform: translateX(-50%);
    width: calc(100% - 24px);
  }
  &:disabled {
    border: solid 1px #dadada !important;
    background-color: #dadada !important;
  }
}
.bottom-button-wrap {
  width: 100%;
}
</style>
